export default '/build/62e89924.svg'